import { render, staticRenderFns } from "./main.vue?vue&type=template&id=d7dae8d2&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=d7dae8d2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7dae8d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7dae8d2')) {
      api.createRecord('d7dae8d2', component.options)
    } else {
      api.reload('d7dae8d2', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=d7dae8d2&scoped=true", function () {
      api.rerender('d7dae8d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/pageHeader/main.vue"
export default component.exports